module.exports = __webpack_public_path__ + "static/img/draw_rule.2463bc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1215/draw_rule.png
// module id = 469
// module chunks = 1